import { PostStatus } from '@libs/types';

export const isActive = (status: PostStatus) => {
  return status === PostStatus.ACTIVE;
};

export const isPending = (status: PostStatus) => {
  return status === PostStatus.PENDING;
};

export const isClosed = (status: PostStatus) => {
  return status === PostStatus.CLOSED;
};

export const isExpired = (status: PostStatus) => {
  return status === PostStatus.EXPIRED;
};
